import GridLoader from './GridLoader';

export default GridLoader;
